// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as RaiseTicketCmp from "./RaiseTicketCmp.bs.js";

function NonOrderRelatedTicketRootCmp(Props) {
  return React.createElement(RaiseTicketCmp.make, {
              crn: undefined
            });
}

var make = NonOrderRelatedTicketRootCmp;

export {
  make ,
  
}
/* react Not a pure module */
